import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';

const TabsState = new Record({
    selectedTabKey: 'all',
});

export default handleActions(
    {
        [Actions.selectTab.type]: (state, {payload}) => {
            return state.merge({
                selectedTabKey: payload.tabKey,
            });
        },
    },
    new TabsState(),
);
